import { useCallback, useContext, useRef } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { EDIT_PAGE_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';

export const useLivePageEditExperience = ({ contentId }: { contentId: string }) => {
	const wasStartedRef = useRef<boolean>(false);
	const experienceTracker = useContext(ExperienceTrackerContext);
	const isLivePage = useIsCurrentPageLive();

	return useCallback(() => {
		if (!wasStartedRef.current && isLivePage) {
			experienceTracker.start({
				name: EDIT_PAGE_EXPERIENCE,
				attributes: {
					contentId,
					isLivePage,
				},
			});
			wasStartedRef.current = true;
		}
	}, [wasStartedRef, experienceTracker, isLivePage, contentId]);
};
